import { getPath } from '@/router/common'
const baseUrl = {
  title: '库存日报表',
  path: 'OperationClassReport'
}

export default [
  {
    path: getPath('ArrivalInventoryDailyReport', baseUrl),
    name: 'OperationClassReport_ArrivalInventoryDailyReport',
    component: () => import(/* webpackChunkName: "OperationClassReport_ArrivalInventoryDailyReport" */ '@/views/operationClassReport/arrivalInventoryDailyReport/index.vue'),
    meta: {
      title: '到货库存日报表'
    }
  }
]
